'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../validationConstants');

var DATE_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.date,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    debounced: true,
    message: 'Not a valid date'
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return;

    var numericValue = parseInt(fieldValue, 10);
    if (isNaN(numericValue)) return DATE_ERROR_OBJECT;

    var date = new Date(numericValue);
    if (isNaN(date.getTime())) return DATE_ERROR_OBJECT;

    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/dateValidator.js
// module id = 2302
// module chunks = 0